import { computed } from "vue";
import { useTenantStore } from "@/stores/tenant";

// Contact types
export const types = [
    {
        id: 1,
        name: "vendors",
        label: "Vendors",
        active: false,
    },
    {
        id: 2,
        name: "landlords",
        label: "Landlords",
        active: false,
    },
    {
        id: 3,
        name: "buyers",
        label: "App / Buyers",
        active: false,
    },
    {
        id: 4,
        name: "tenants",
        label: "App / Tenants",
        active: false,
    },
    {
        id: 5,
        name: "suppliers",
        label: "Suppliers",
        active: false,
    },
];

// Check contact types
export const checkedTypes = (type) => {
    const typesClone = JSON.parse(JSON.stringify(types));
    let result = [];
    const contactType = parseInt(type);

    if (contactType === 3) {
        result = typesClone;
    } else if (contactType === 1) {
        result = typesClone.filter((item) => item.id === 1 || item.id === 3 || item.id === 5);
    } else if (contactType === 2) {
        result = typesClone.filter((item) => item.id === 2 || item.id === 4 || item.id === 5);
    }

    if (result.length > 0) {
        result[0].active = true;
    }

    return result.map((obj) => {
        return { ...obj, value: obj.id };
    });
};

export const convertJsonToFormData = (data, formData = new FormData(), parentKey = "") => {
    const isFile = (val) => val instanceof File || val instanceof Blob;

    Object.entries(data).forEach(([key, value]) => {
        const formKey = parentKey ? `${parentKey}[${key}]` : key;

        if (value === null) return;

        if (typeof value === "boolean") {
            formData.append(formKey, value ? 1 : 0);
        } else if (isFile(value)) {
            formData.append(formKey, value);
        } else if (Array.isArray(value)) {
            value.forEach((item, index) => {
                if (isFile(item)) {
                    formData.append(`${formKey}[]`, item);
                } else if (typeof item === "object") {
                    convertJsonToFormData(item, formData, `${formKey}[${index}]`);
                } else {
                    formData.append(`${formKey}[]`, item);
                }
            });
        } else if (typeof value === "object") {
            convertJsonToFormData(value, formData, formKey);
        } else {
            formData.append(formKey, value);
        }
    });

    return formData;
};

const labelColors = {
    blue_label: "#00aff5",
    teal_label: "#3de6b7",
    lightred_label: "#ff5858",
    lightorange_label: "#ffad29",
    purple_label: "#a597ff",
    aqua_label: "#6fd6f8",
    darkblue_label: "#34a2cb",
    darkgreen_label: "#5cc5bb",
    parrot_label: "#bcd245",
    fadegreen_label: "#77b176",
    darkergreen_label: "#588b59",
    darkpurple_label: "#8780b0",
    purepurple_label: "#713c89",
    lightpink_label: "#f68aab",
    pink_label: "#f463a9",
    fadeorange_label: "#f68662",
    winered_label: "#d43f3a",
    darkorange_label: "#f66c2e",
    yellow_label: "#fae24f",
    lightgray_label: "#dadbdc",
    gray_label: "#9a9b9f",
    darkgray_label: "#6b6b6d",
};

export const getColorFromLabel = (input) => {
    const label = input.toLowerCase();

    if (labelColors[label]) {
        return labelColors[label];
    }

    const isHexColor = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(input);
    if (isHexColor) {
        return input;
    }

    console.warn(`Unknown label or color: ${input}`);
    return null;
};

export const getLabelFromColor = (color) => {
    return Object.keys(labelColors).find((label) => label === color) || null;
};

// Get client portal URL - Check if the "client_portal_url" is set in the tenant store
export const getClientPortalUrl = computed(() => {
    const tenantStore = useTenantStore();
    return tenantStore && tenantStore.getTenant?.client_portal_url;
});

// [info]: need it for now. but can be removed later
export const formateMessageObject = (chatObject, isAgent) => {
    const date = chatObject.createdAt.split("T")[0];
    const sender = chatObject.sender;
    const chat = chatObject.chat;

    const object = {
        _id: date,
        docs: [
            {
                _id: chatObject._id,
                sender: {
                    _id: sender._id,
                    firstName: sender.firstName,
                    lastName: sender.lastName,
                    email: sender.email,
                    pic: sender.pic,
                    status: "Online",
                    role: isAgent ? "Agent" : "Contact",
                },
                content: chatObject.content,
                note: chatObject.note,
                contentType: chatObject.contentType,
                chat: {
                    _id: chat._id,
                    chatName: chat.chatName,
                    isGroupChat: chat.isGroupChat,
                    users: chat.users.map((user) => user._id),
                    tenantId: chatObject.chat.tenantId,
                    labels: chat.labels,
                    chatStatus: chat.chatStatus,
                    bot_id: chat.bot_id,
                    createdAt: chat.createdAt,
                    updatedAt: chat.updatedAt,
                    __v: chat.__v,
                    latestMessage: chat.latestMessage,
                },
                readBy: chatObject.readBy,
                sentFrom: chatObject.sentFrom,
                tenantId: chatObject.tenantId,
                messageType: chatObject.messageType,
                wpMsgId: chatObject.wpMsgId,
                reactions: chatObject.reactions,
                emailMetadata: chatObject.emailMetadata,
                botLinkedData: chatObject.botLinkedData,
                createdAt: chatObject.createdAt,
                updatedAt: chatObject.updatedAt,
                __v: chatObject.__v,
            },
        ],
    };
    return object;
};

/**
 * return a string with first letter capitalize
 * @param {String} str
 * @return {String} - String with first letter capitalize
 */
export const capitalizeFirstLetter = (str) => {
    if (!str) return "";
    return String(str).charAt(0).toUpperCase() + String(str).slice(1);
};

/**
 * [info]: creates a badge name with firstName otherwise return the default one name_icon_q which i guess is blue
 * @param {String} firstName - firstName of the user
 * @returns {String} - returns a badge name
 */
export const createBadgeNameWithFirstName = (firstName) => {
    if (!firstName && firstName?.length <= 0) return "name_icon_q";
    return `name_icon_${firstName[0].toLowerCase()}`;
};

/**
 *
 * @param {Number | String} number - Number you need to convert into 2 decimals
 * @returns - return a 2 decimal string with error handling
 */
export const CustomToFixed = (number) => {
    if (number === null || number === undefined) return "n/a";

    return Number(number || "0").toFixed(2);
};
